// @flow

import moment from 'moment';

import type { Shift } from '../../common/typings';

export default function getShiftDescription(shift: Shift | null): string {
  if (!shift) {
    return 'You do not have a shift scheduled';
  }

  let label = 'Your shift';

  const now = new Date();
  if (shift.dtstart < now) {
    //@TODO: should be dtstartLocal
    label = `${label} started`;
  } else {
    label = `${label} starts`;
  }

  label = `${label} ${moment(shift.dtstart).fromNow()}`;

  return label;
}
